module.exports = __webpack_public_path__ + "img/eg-22-01.ab63bfde.jpg";